import { connect } from 'react-redux'

const mapStateToProps = ({ lead, positions, selectedPosition }, ownProps) => ({
  ...ownProps,
  isAuthorized: lead.secret_token !== null,
  position: selectedPosition || (positions && positions[0]),
})

export default connect(mapStateToProps)



// WEBPACK FOOTER //
// ./src/components/Position/positionContainer.js